import { EnumCashJournalPositionBookingType } from './Generated';
import { II18NNamed, IValue } from '@synqo/frontend-component-library';

export const getEnumCashJournalPositionBookingTypeLabel = (value: EnumCashJournalPositionBookingType) => {
    switch (value) {
        case EnumCashJournalPositionBookingType.Automatic:
            return 'Automatisch';
        case EnumCashJournalPositionBookingType.Bank:
            return 'Bankbuchung';
        case EnumCashJournalPositionBookingType.ExternalReceipt:
            return 'Externer Beleg';
        default:
            return 'Nicht definiert';
    }
};

export const enumCashJournalPositionBookingTypeItems: (II18NNamed & IValue<EnumCashJournalPositionBookingType>)[] = [
    {
        name: 'automatic',
        label: getEnumCashJournalPositionBookingTypeLabel(EnumCashJournalPositionBookingType.Automatic),
        value: EnumCashJournalPositionBookingType.Automatic,
    },
    {
        name: 'bank',
        label: getEnumCashJournalPositionBookingTypeLabel(EnumCashJournalPositionBookingType.Bank),
        value: EnumCashJournalPositionBookingType.Bank,
    },
    {
        name: 'external_receipt',
        label: getEnumCashJournalPositionBookingTypeLabel(EnumCashJournalPositionBookingType.ExternalReceipt),
        value: EnumCashJournalPositionBookingType.ExternalReceipt,
    },
];
